import React from 'react';
import { Link } from 'react-router-dom';
import ThemeSwitcher from './ThemeSwitcher';
import MobileMenu from './MobileMenu';
import './Layout.css';

function Layout({ children, darkMode, setDarkMode }) {
  return (
    <div className={`app ${darkMode ? 'dark' : ''}`}>
      {/* Header */}
      <header className="header">
        <div className="header-content">
          <div className="header-left">
            <Link to="/" className="logo-link">
              <h1 className="logo">Stick Yours</h1>
            </Link>
            <Link to="/" className="home-link">Home</Link>
          </div>
          <div className="header-right">
            <MobileMenu />
            <ThemeSwitcher darkMode={darkMode} setDarkMode={setDarkMode} />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="main-content">
        {children}
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-links">
            <Link to="/about" className="footer-link">About Us</Link>
            <Link to="/contact" className="footer-link">Contact Us</Link>
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-link">Terms & Conditions</Link>
            <Link to="/disclaimer" className="footer-link">Disclaimer</Link>
          </div>
          <p className="footer-text">
            100% Client-Side Processing • Your images never leave your device
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
